
import { ActionReducerMap } from '@ngrx/store';
import { sessionReducer } from './session.reducer';
import { AppState } from '../states/app.state';
import { currentUserReducer } from './user.reducer';
import { navigationReducer } from './navigation.reducer';



export const reducers: ActionReducerMap<AppState> = {
  session: sessionReducer,
  currentUser: currentUserReducer,
  navigation: navigationReducer,
};
